import { render, staticRenderFns } from "./LegalDocumentComponent.vue?vue&type=template&id=0f52798a&"
import script from "./LegalDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports